import { type ComponentType } from "react";
import QRCodeModule, { type QRCodeProps } from "react-qr-code";
import { unwrapModuleDefault } from "./internal/interop";

const QRCodeComponent = unwrapModuleDefault<ComponentType<QRCodeProps>>(QRCodeModule);

export type { QRCodeProps };

export default function QRCode(props: QRCodeProps) {
	return <QRCodeComponent {...props} />;
}
